import React from 'react';
import './ConfirmationDialog.css';

const ConfirmationDialog = ({
  isOpen,
  onConfirm,
  onCancel,
  title = 'Clear and Reset',
  message = 'This action will clear all images in view and reset app settings!',
  warning = 'This action cannot be undone.',
  confirmLabel = 'Clear and Reset',
  showCancel = true
}) => {
  if (!isOpen) return null;

  return (
    <div className="dialog-overlay" onClick={onCancel}>
      <div className="dialog-container glass-card" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h3 className="dialog-title">
            {title}
            <div className="warning-icon">⚠️</div>
          </h3>
        </div>

        <div className="dialog-content">
          <p className="dialog-message">
            {message}
          </p>
          <p className="dialog-warning">
            <strong>{warning}</strong>
          </p>
        </div>

        <div className="dialog-actions confirmation-dialog-actions">
          {showCancel && (
            <button
              className="glass-button glass-button-secondary"
              onClick={onCancel}
            >
              Cancel
            </button>
          )}
          <button
            className="glass-button dialog-confirm-button"
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;
